import React, { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import CardWrap from "../Common/CardWrap";
import { userServices } from "../../Services/user.service";
import Tooltip from "../Common/Tooltip";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { validationService } from "../../Services/validation.service";
import { roles as roleGrupus } from "../../Config/Roles";
import {
  email,
  PIN,
  lettersAndNumbers,
  phoneNumber,
  numbersOnly,
  lettersOnly,
} from "../../Config/Regex";
import SpinnerLoading from "../Common/SpinnerLoading";

export default function UpdateUser(props) {
  let id = props.match.params.userId;
  const { locName, locUser } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const [roles, setRoles] = useState([]);
  const [pinType, setPinType] = useState("password");
  const [backUrl, setBackUrl] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { master, admin, support } = roleGrupus;
  const [user, setUser] = useState({
    userId: props.userId,
    tenantId: null,
    isActive: true,
    loginName: "",
    realName: "",
    printName: "",
    personalIdentificationNumber: "",
    phone: "",
    email: "",
    pin: "",
    roleId: null,
    posDiscountEdit: false,
    posPriceEdit: false,
    posProductEdit: false,
    posInvoiceCopyEdit: false,
    posHardReset: false,
    posCashierEdit: false,
    posCodeBookEdit: false,
    posDraftEdit: false,
    posDuplicateEdit: false,
    posStornoEdit: false,
    rfidTag: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const goBack = () => {
    history.push(backUrl);
  };

  const handleClose = () => {
    setModal({ show: false });
    goBack();
  };

  const { register, handleSubmit, errors, formState, watch } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: { user },
  });
  const isTempUser = Boolean(watch("tempUser", user.tempUser));

  useEffect(() => {
    setBackUrl(`/${locName}/${locUser != 0 ? locUser : ""}`);
    userServices
      .getRoles(Number(roleId))
      .then((res) => {
        setRoles(res.data);
      })
      .catch((err) => console.log(err));

    if (id) {
      setIsLoading(true);
      userServices
        .getById(id)
        .then((res) => {
          setUser(res.data);
        })
        .catch((err) => console.log(err.response))
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  const history = useHistory();

  async function loginNameValidation(loginName) {
    if (loginName != user.loginName && user.loginName.length >= 4) {
      return await validationService.validateLoginName(loginName);
    } else {
      return true;
    }
  }

  const onSubmit = (data) => {
    userServices
      .update({
        userId: id,
        isActive: data.isActive,
        loginName: isTempUser ? "" : data.loginName,
        realName: data.realName,
        printName: isTempUser ? "" : data.printName,
        personalIdentificationNumber: isTempUser
          ? ""
          : data.personalIdentificationNumber,
        phone: isTempUser ? "" : data.phone,
        email: data.email,
        pin: data.pin,
        tempUser: isTempUser,
        roleId: Number(data.roleId),
        posPriceEdit: data.posPriceEdit,
        posDiscountEdit: data.posDiscountEdit,
        posProductEdit: data.posProductEdit,
        posInvoiceCopyEdit: data.posInvoiceCopyEdit,
        posHardReset: data.posHardReset,
        posCashierEdit: data.posCashierEdit,
        posCodeBookEdit: data.posCodeBookEdit,
        posDraftEdit: data.posDraftEdit,
        posDuplicateEdit: data.posDuplicateEdit,
        posStornoEdit: data.posStornoEdit,
        rfidTag: data.RFIDtag,
      })
      .then((res) => {
        res.data.success
          ? setModal({
              show: true,
              title: translator("User-Update-SuccessModal-Title"),
              text: translator("User-Update-SuccessModal-Text"),
              btnClass: "btn btn-primary",
            })
          : setModal({
              show: true,
              title: translator("User-Update-UnsuccessfulModal-Title"),
              text: translator("User-Update-UnsuccessfulModal-Text"),
              btnClass: "btn btn-primary",
            });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("User-Update-UnsuccessfulModal-Title"),
          text: translator("User-Update-UnsuccessfulModal-Text"),
          btnClass: "btn btn-primary",
        })
      );
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <CardWrap
      subtitle={translator("UpdateUser-Subtitle-UserEditing")}
      entity={user.realName}
      backUrl={backUrl}
    >
      {isLoading && <SpinnerLoading />}
      {!isLoading && (
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          {/* <div className="col-lg-12">
            <div className="form-group">
              <label className="labelCont">
                <input
                  ref={register}
                  type="checkbox"
                  name="tempUser"
                  defaultChecked={user.tempUser}
                />
                <span className="checkmark"></span>
              </label>
              <span className="Data">{translator("AddUser-TempUser")}</span>
            </div>
          </div> */}
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("User-Update-PersonalData")}
              </legend>
              <div className="form-group">
                <label>{translator("User-Update-OIB")}</label>{" "}
                <Tooltip text={translator("Users-OIB-Msg")} />
                <input
                  disabled={
                    isTempUser ||
                    ![master, admin, support].includes(Number(roleId))
                  }
                  type="text"
                  className="form-control"
                  ref={register({
                    required: !isTempUser,
                    minLength: isTempUser ? undefined : 11,
                    maxLength: isTempUser ? undefined : 11,
                    validate: isTempUser
                      ? undefined
                      : () =>
                          document.getElementsByName(
                            "personalIdentificationNumber"
                          )[0].value !== user.personalIdentificationNumber
                            ? validationService.validateUserOib(
                                document.getElementsByName(
                                  "personalIdentificationNumber"
                                )[0].value
                              )
                            : true,
                  })}
                  name="personalIdentificationNumber"
                  defaultValue={user.personalIdentificationNumber}
                />
                {!isTempUser &&
                  errors.personalIdentificationNumber &&
                  errors.personalIdentificationNumber.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.personalIdentificationNumber &&
                  (errors.personalIdentificationNumber.type === "minLength" ||
                    errors.personalIdentificationNumber.type ===
                      "maxLength") && (
                    <p className="text-danger">
                      {translator("ValidationMsg-OIBLength")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.personalIdentificationNumber &&
                  errors.personalIdentificationNumber.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-OIBNotValid")}
                    </p>
                  )}
              </div>
              <div className="form-group">
                <label>{translator("User-Update-FullName")}</label>{" "}
                <Tooltip text={translator("Users-FullName-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    required: true,
                    maxLength: 50,
                    pattern: lettersOnly,
                  })}
                  name="realName"
                  defaultValue={user.realName}
                />
                {errors.realName && errors.realName.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.realName && errors.realName.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength50")}
                  </p>
                )}
                {errors.realName && errors.realName.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-LettersOnly")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("User-Update-Role")}</label>{" "}
                <Tooltip text={translator("Users-Role-Msg")} />
                <select
                  name="roleId"
                  className="form-control"
                  ref={register({ required: true })}
                  disabled={
                    [master, admin, support].includes(Number(roleId))
                      ? false
                      : true
                  }
                >
                  {roles.map((e, key) => {
                    return (
                      <option
                        selected={user.roleId == e.id}
                        key={key}
                        value={e.id}
                      >
                        {translator(e.name)}
                      </option>
                    );
                  })}
                </select>
              </div>
            </fieldset>
          </div>
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("User-Update-UserData")}
              </legend>
              <div className="form-group">
                <label>{translator("Users-Create-Print-Name")}</label>{" "}
                <Tooltip
                  text={translator("Users-Create-TooltipPrintNameMsg")}
                />
                <input
                  type="text"
                  className="form-control"
                  disabled={isTempUser}
                  ref={register({
                    required: !isTempUser,
                    pattern: isTempUser ? undefined : lettersAndNumbers,
                    maxLength: isTempUser ? undefined : 20,
                  })}
                  name="printName"
                  defaultValue={user.printName}
                />
                {!isTempUser &&
                  errors.printName &&
                  errors.printName.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.printName &&
                  errors.printName.type === "lettersAndNumbers" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-LettersAndNumbers")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.printName &&
                  errors.printName.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength20")}
                    </p>
                  )}
              </div>
              <div className="form-row">
                <div className="form-group col-md-6 col-xs-12">
                  <label>{translator("User-Update-UserName")}</label>{" "}
                  <Tooltip text={translator("Users-UserName-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    disabled={isTempUser}
                    ref={register({
                      required: !isTempUser,
                      pattern: isTempUser ? undefined : lettersAndNumbers,
                      maxLength: isTempUser ? undefined : 20,
                      minLength: isTempUser ? undefined : 4,
                      validate: isTempUser
                        ? undefined
                        : () =>
                            loginNameValidation(
                              document.getElementsByName("loginName")[0]
                                .value
                            ),
                    })}
                    name="loginName"
                    defaultValue={user.loginName}
                  />
                  {!isTempUser &&
                    errors.loginName &&
                    errors.loginName.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  {!isTempUser &&
                    errors.loginName &&
                    errors.loginName.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-LettersAndNumbers")}
                      </p>
                    )}
                  {!isTempUser &&
                    errors.loginName &&
                    errors.loginName.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-User-LoginName")}
                      </p>
                    )}
                  {!isTempUser &&
                    errors.loginName &&
                    errors.loginName.type === "minLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MinLength4")}
                      </p>
                    )}
                  {!isTempUser &&
                    errors.loginName &&
                    errors.loginName.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength20")}
                      </p>
                    )}
                </div>
                {/* <div className="form-row"> */}
                {/* <div className="form-group col-md-6 col-xs-12">
                <label>{translator("Users-Create-RFIDtag")}</label>{" "}
                <Tooltip text={translator("Users-Create-TooltipRFIDtageMsg")} />
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    required: true,
                    pattern: numbersOnly,
                    maxLength: 10,
                  })}
                  name="RFIDtag"
                  defaultValue={user.rfidTag}
                />
                {errors.RFIDtag &&
                  errors.RFIDtag.type === "lettersAndNumbers" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-NumbersOnly")}
                    </p>
                  )}
                {errors.RFIDtag && errors.RFIDtag.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength10")}
                  </p>
                )}
              </div> */}
                <div className="form-group col-md-6 col-xs-12">
                  <label>PIN</label>{" "}
                  <Tooltip text={translator("Users-Create-TooltipPINMsg")} />
                  <input
                    type={pinType}
                    className="form-control"
                    ref={register({
                      required: true,
                      pattern: PIN,
                      validate: () =>
                        document.getElementsByName("pin")[0].value !== user.pin
                          ? validationService.validateUserPin(
                              document.getElementsByName("pin")[0].value,
                              user.tenantId
                            )
                          : true,
                    })}
                    name="pin"
                    defaultValue={user.pin}
                  />
                  <span
                    className="show-pin"
                    onMouseDown={() => setPinType("text")}
                    onMouseUp={() => setPinType("password")}
                    onMouseLeave={() => setPinType("password")}
                    onTouchStart={() => setPinType("text")}
                    onTouchCancel={() => setPinType("password")}
                  >
                    <i className="fas fa-eye text-dark"></i>
                  </span>
                  {errors.pin && errors.pin.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.pin && errors.pin.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-PIN")}
                    </p>
                  )}
                  {errors.pin && errors.pin.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-PIN-InUse")}
                    </p>
                  )}
                </div>
              </div>
              {/* </div> */}
              <div className="form-group">
                <label>{translator("User-Update-PhoneNumber")}</label>{" "}
                <Tooltip text={translator("Users-PhoneNumber-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  disabled={isTempUser}
                  ref={register({
                    required: !isTempUser,
                    pattern: isTempUser ? undefined : numbersOnly,
                    maxLength: isTempUser ? undefined : 20,
                  })}
                  name="phone"
                  defaultValue={user.phone}
                />
                {!isTempUser &&
                  errors.phone &&
                  errors.phone.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.phone &&
                  errors.phone.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-PhoneNumber")}
                    </p>
                  )}
                {!isTempUser &&
                  errors.phone &&
                  errors.phone.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength20")}
                    </p>
                  )}
              </div>
              <div className="form-group">
                <label>Email</label>{" "}
                <Tooltip text={translator("Users-Email-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    required: true,
                    pattern: email,
                    maxLength: 50,
                  })}
                  name="email"
                  defaultValue={user.email}
                />
                {errors.email && errors.email.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.email && errors.email.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-Email")}
                  </p>
                )}
                {errors.email && errors.email.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength50")}
                  </p>
                )}
              </div>
            </fieldset>
          </div>
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("Users-Create-MoreInformation")}
              </legend>
              <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posPriceEdit"
                      defaultChecked={user.posPriceEdit}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">
                  {translator("AddUser-PriceEditing")}
                </span>{" "}
                <Tooltip text={translator("Users-PriceEditing-Msg")} />
              </div>
              <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posDiscountEdit"
                      defaultChecked={user.posDiscountEdit}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">
                  {translator("AddUser-DiscountEditing")}
                </span>{" "}
                <Tooltip text={translator("Users-DiscountEditing-Msg")} />
              </div>
              <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posProductEdit"
                      defaultChecked={user.posProductEdit}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">{translator("AddUser-ProductEdit")}</span>
              </div>
              <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posInvoiceCopyEdit"
                      defaultChecked={user.posInvoiceCopyEdit}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">{translator("AddUser-InvoiceCopyEdit")}</span>
              </div>
              <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posHardReset"
                      defaultChecked={user.posHardReset}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">{translator("AddUser-HardReset")}</span>
              </div>
              <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posCashierEdit"
                      defaultChecked={user.posCashierEdit}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">{translator("AddUser-CashierEdit")}</span>
              </div>
              <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posCodeBookEdit"
                      defaultChecked={user.posCodeBookEdit}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">{translator("AddUser-CodeBookEdit")}</span>
              </div>
              <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posDraftEdit"
                      defaultChecked={user.posDraftEdit}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">{translator("AddUser-DraftEdit")}</span>
              </div>
              <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posDuplicateEdit"
                      defaultChecked={user.posDuplicateEdit}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">{translator("AddUser-DuplicateEdit")}</span>
              </div>
               <div className="form-group">
                <label className="labelCont">
                  {user.loginName !== "" && (
                    <input
                      type="checkbox"
                      name="posStornoEdit"
                      defaultChecked={user.posStornoEdit}
                      ref={register}
                    />
                  )}
                  <span className="checkmark"></span>
                </label>
                <span className="Data">{translator("AddUser-StornoEdit")}</span>
              </div>
            </fieldset>
          </div>
          <div
            className="container-fluid"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("Btn-Cancel")}
            </button>
            &nbsp;
            <button
              disabled={!formState.dirty}
              className="btn btn-primary"
              type="submit"
            >
              {translator("Btn-Save")}
            </button>
          </div>
        </form>
      )}
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
}
